(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/customer-service/views/phone.js') >= 0) return;  svs.modules.push('/modules/customer-service/views/phone.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.customer_service=_svs.customer_service||{};
_svs.customer_service.templates=_svs.customer_service.templates||{};
svs.customer_service.templates.phone = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"f-content f-700 padding-bottom-1\">Ring oss</div>\n<p>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.phone : depth0)) != null ? stack1.openTime : stack1), depth0))
    + "</p>\n<div class=\"f-content f-800 fc-blue\"><a href=\"tel:0770 - 11 11 11\">0770 - 11 11 11</a></div>";
},"useData":true});
Handlebars.partials['svs-customer_service-phone'] = svs.customer_service.templates.phone;
})(svs, Handlebars);

 })(window);